import apiClient from "../../../api/apiClient";
import { UnifiedResponse } from "../../../models/Response/unifiedResponse";
import { localStorageService } from "../../../services";
import { ChangePasswordRequest } from "../models/request/changePasswordRequest";
import { AnnouncementListResponse } from "../models/response/announcementRetrieveResponse";
import { UserProfileUpdateRequest } from "../models/request/userProfileUpdateRequest";
import { UserPendingDataResponse } from "../models/response/userPendingDataResponse";
import { UserProfileResponse } from "../models/response/userProfileResponse";
import { UpdateUserBiometricsRequest } from "../models/request/updateUserBiometricsRequest";
import { DocumentUploadRequest } from "../models/request/documentUploadRequest";

export const userApi = {
  getUserProfile: async (): Promise<UnifiedResponse<UserProfileResponse>> => {
    const response =
      await apiClient.get<UnifiedResponse<UserProfileResponse>>(
        "/account/profile",
      );
    return response.data;
  },

  updateUserLanguage: async (
    languageCode: string,
  ): Promise<UnifiedResponse<any>> => {
    const response = await apiClient.post<UnifiedResponse<any>>(
      "account/update_user_language",
      { languageCode },
    );
    return response.data;
  },

  updateUserProfile: async (
    data: UserProfileUpdateRequest,
  ): Promise<UnifiedResponse<UserProfileResponse>> => {
    const response = await apiClient.post<UnifiedResponse<UserProfileResponse>>(
      "/account/profile/update",
      data,
    );
    return response.data;
  },

  changePassword: async (
    data: ChangePasswordRequest,
  ): Promise<UnifiedResponse<any>> => {
    const response = await apiClient.post<UnifiedResponse<any>>(
      "/account/change_password",
      data,
    );
    return response.data;
  },

  sendEmailVerificationCodeOld: async (): Promise<UnifiedResponse<any>> => {
    const response = await apiClient.get<UnifiedResponse<any>>(
      "/users/send_email_otp_old",
    );
    return response.data;
  },

  verifyEmailVerificationCodeOld: async (
    code: string,
  ): Promise<UnifiedResponse<any>> => {
    const response = await apiClient.post<UnifiedResponse<any>>(
      "/users/verify_email_otp_old",
      { otp: code },
    );
    return response.data;
  },

  sendEmailVerificationCode: async (
    userId: string,
    email: string,
  ): Promise<UnifiedResponse<any>> => {
    const response = await apiClient.post<UnifiedResponse<any>>(
      "/users/send_email_otp",
      {
        userId,
        email,
      },
    );
    return response.data;
  },

  verifyEmailVerificationCode: async (
    userId: string,
    code: string,
  ): Promise<UnifiedResponse<any>> => {
    const response = await apiClient.post<UnifiedResponse<any>>(
      "/users/verify_email_otp",
      {
        userId,
        otp: code,
      },
    );

    return response.data;
  },
  sendMobileVerificationCodeOld: async (): Promise<UnifiedResponse<any>> => {
    const response = await apiClient.get<UnifiedResponse<any>>(
      "/users/send_mobile_otp_old",
    );
    return response.data;
  },

  verfiyMobileVerificationCodeOld: async (
    code: string,
  ): Promise<UnifiedResponse<any>> => {
    const response = await apiClient.post<UnifiedResponse<any>>(
      "/users/verify_mobile_otp_old",
      { otp: code },
    );
    return response.data;
  },

  sendMobileVerificationCode: async (
    userId: string,
    mobile: string,
    countryCode: string,
  ): Promise<UnifiedResponse<any>> => {
    const response = await apiClient.post<UnifiedResponse<any>>(
      "/users/send_mobile_otp",
      {
        userId,
        mobile,
        countryCode,
      },
    );
    return response.data;
  },

  verfiyMobileVerificationCode: async (
    userId: string,
    code: string,
  ): Promise<UnifiedResponse<any>> => {
    const response = await apiClient.post<UnifiedResponse<any>>(
      "/users/verify_mobile_otp",
      {
        userId,
        otp: code,
      },
    );

    return response.data;
  },

  updateUserSecondLoginData: async (
    userId: string,
  ): Promise<UnifiedResponse<any>> => {
    const response = await apiClient.post<UnifiedResponse<any>>(
      "/account/secondlogin/update",
      { id: userId },
    );
    return response.data;
  },

  resetPassword: async (
    password: string,
    confirmPassword: string,
  ): Promise<UnifiedResponse<any>> => {
    const response = await apiClient.post<UnifiedResponse<any>>(
      "/account/reset_password",
      {
        password,
        confirmPassword,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorageService.getItem("resetToken")}`,
        },
      },
    );
    return response.data;
  },

  retrieveAnnouncements: async (
    data: { LanguageCode: string },
  ): Promise<UnifiedResponse<AnnouncementListResponse>> => {
    const response = await apiClient.post<
      UnifiedResponse<AnnouncementListResponse>
    >("/announcement/retrieve", {
      LanguageCode: data.LanguageCode,
    });
    return response.data;
  },

  fetchUserPendingData: async (): Promise<UnifiedResponse<UserPendingDataResponse>> => {
    const response = await apiClient.get<UnifiedResponse<UserPendingDataResponse>>(
      "/payment/users_pending_data/list",
    );
    return response.data;
  },

  updateUserBiometrics: async (
    data: UpdateUserBiometricsRequest,
  ): Promise<UnifiedResponse<any>> => {
    const response = await apiClient.post<UnifiedResponse<any>>(
      "/users/check_password",
      data,
    );
    return response.data;
  },

  uploadUserAvatar: async (
    data: DocumentUploadRequest,
  ): Promise<UnifiedResponse<any>> => {
    const response = await apiClient.post<UnifiedResponse<any>>(
      "/users/avatar/upload",
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );
    return response.data;
  },
};

export default userApi;
